import { useMemo, useState, useEffect } from 'react';
import jobsAPI from '../API/jobsAPI';
import { useAuth } from '../Auth';


export const useJobs = () => {
    const [ jobs, setJobs ] = useState(null);
    const [ active, setActive ] = useState(false);
    const { userObj } = useAuth();

    useEffect(() => {
        const handleGetJobData = async () => {
            try {
                await jobsAPI.getJobData().then(res => {
                    if (res.data) {
                        setJobs(res.data);
                    } else {
                        setJobs(null);
                    };
                });
            } catch (err) {
                console.log(err);
            };
        };

        if (userObj?.jobs) {
            setActive(true);
            handleGetJobData();
        } else {
            setActive(false);
        };

    },[userObj?.jobs]);

    return useMemo(() => ({active, jobs}), [active, jobs])
};